export const COOKIE_NAME = 'skipDatesModal';
